import { SimpleError } from '@common/errors';
class NumberDecoder {
    decode(data) {
        if (typeof data.value === 'number' && !Number.isNaN(data.value) && Number.isFinite(data.value)) {
            return data.value;
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: `Expected a number at ${data.currentField}`,
            field: data.currentField,
        });
    }
    decodeField(data, _, currentField) {
        if (typeof data === 'number' && !Number.isNaN(data) && Number.isFinite(data)) {
            return data;
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: `Expected a number at ${currentField}`,
            field: currentField,
        });
    }
}
// We export an instance to prevent creating a new instance every time we need to decode a number
export default new NumberDecoder();
//# sourceMappingURL=NumberDecoder.js.map